module.exports = __webpack_public_path__ + "images/questions/qa_hero_bg_de6e6a0c4100358bdca10059a418bb9e.jpg";